// extracted by mini-css-extract-plugin
export default {"light":"TextButton_light__C3Bxn","dark":"TextButton_dark__bRXkP","selected":"TextButton_selected__8fvwz","speciesSelected":"TextButton_speciesSelected__vo1HU"};